/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Equipment_Quick_Full_GymInputs */

const en_us2_equipment_quick_full_gym = /** @type {(inputs: Equipment_Quick_Full_GymInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Full gym`)
};

const pt_br2_equipment_quick_full_gym = /** @type {(inputs: Equipment_Quick_Full_GymInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Academia completa`)
};

const es_419_equipment_quick_full_gym = /** @type {(inputs: Equipment_Quick_Full_GymInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gimnasio completo`)
};

const pt_pt2_equipment_quick_full_gym = /** @type {(inputs: Equipment_Quick_Full_GymInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ginásio completo`)
};

const fr_fr2_equipment_quick_full_gym = /** @type {(inputs: Equipment_Quick_Full_GymInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Salle complète`)
};

const de_de2_equipment_quick_full_gym = /** @type {(inputs: Equipment_Quick_Full_GymInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Volles Studio`)
};

const it_it2_equipment_quick_full_gym = /** @type {(inputs: Equipment_Quick_Full_GymInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Palestra completa`)
};

/**
* | output |
* | --- |
* | "Full gym" |
*
* @param {Equipment_Quick_Full_GymInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const equipment_quick_full_gym = /** @type {((inputs?: Equipment_Quick_Full_GymInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Equipment_Quick_Full_GymInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_equipment_quick_full_gym(inputs)
	if (locale === "es-419") return es_419_equipment_quick_full_gym(inputs)
	if (locale === "pt-PT") return pt_pt2_equipment_quick_full_gym(inputs)
	if (locale === "fr-FR") return fr_fr2_equipment_quick_full_gym(inputs)
	if (locale === "de-DE") return de_de2_equipment_quick_full_gym(inputs)
	if (locale === "it-IT") return it_it2_equipment_quick_full_gym(inputs)
	return en_us2_equipment_quick_full_gym(inputs)
});
export { equipment_quick_full_gym as "equipment.quick.full_gym" }